import React from "react";
import { createPortal } from "react-dom";
import { PRODUCT_VISIBILITY_OPTIONS } from "../constants/productVisibility";

export default function ProductCatalogDialog({
  title,
  productName,
  visibility,
  onClose,
  closeDisabled = false,
  children,
}) {
  const visibilityLabel = PRODUCT_VISIBILITY_OPTIONS.find(
    (option) => option.value === visibility,
  )?.label;

  return createPortal(
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-2">
      <section
        role="dialog"
        aria-modal="true"
        aria-labelledby="product-catalog-dialog-title"
        className="flex h-[min(94vh,56rem)] max-h-[98vh] w-full max-w-screen-2xl flex-col overflow-hidden rounded-xl border border-zinc-300 bg-white shadow-2xl"
      >
        <header className="flex shrink-0 items-center justify-between gap-4 border-b border-zinc-200 bg-white px-5 py-3">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-[0.14em] text-blue-700">
              {productName} catalog
            </p>
            <h2
              id="product-catalog-dialog-title"
              className="mt-0.5 text-lg font-semibold leading-5 text-zinc-950"
            >
              {title}
            </h2>
            {visibilityLabel && (
              <span
                className={`mt-1 inline-flex rounded-full px-2 py-0.5 text-[10px] font-semibold ${
                  visibility === "PUBLISHED"
                    ? "bg-green-100 text-green-800"
                    : "bg-amber-100 text-amber-900"
                }`}
                aria-label={`Current visibility: ${visibilityLabel}`}
              >
                {visibilityLabel}
              </span>
            )}
          </div>
          <button
            type="button"
            aria-label="Close dialog"
            onClick={onClose}
            disabled={closeDisabled}
            className="rounded px-2 py-1 text-2xl leading-none text-gray-600 hover:bg-gray-100 disabled:opacity-50"
          >
            ×
          </button>
        </header>
        <div className="min-h-0 flex-1 overflow-y-auto">{children}</div>
      </section>
    </div>,
    document.body,
  );
}
